/**
 * Badge rendering for the product card broken-image diagnostic (ISS-04-093)
 */

// Standard HTTP reason phrases for the codes this feature actually surfaces,
// plus our own sentinels (TIMEOUT/ERR/INVALID — see product-card-image-error-api.ts).
const STATUS_DESCRIPTIONS: Record<string, string> = {
    "400": "Bad Request",
    "401": "Unauthorized",
    "403": "Forbidden — often a hotlink/geo (country) block",
    "404": "Not Found",
    "410": "Gone",
    "429": "Too Many Requests",
    "500": "Internal Server Error",
    "502": "Bad Gateway",
    "503": "Service Unavailable",
    "504": "Gateway Timeout",
    TIMEOUT: "Connection timed out — host unreachable",
    ERR: "Request failed — network error or unreachable host",
    INVALID: "Image URL is missing or not a safe public URL",
};

class ProductCardImageErrorRender {
    /**
     * .product-image-badges only exists in the DOM when <x-product-badges>
     * actually rendered a rank/NEW badge — most products have neither, so the
     * container has to be created on demand rather than assumed present.
     */
    public static ensureBadgesContainer(wrapper: HTMLElement, existing: HTMLElement | null): HTMLElement {
        if (existing) {
            return existing;
        }

        const container = document.createElement("div");
        container.className = "product-image-badges";
        wrapper.appendChild(container);
        return container;
    }

    public static appendStatusBadge(container: HTMLElement, statusLabel: string, imageUrl: string): void {
        const description = STATUS_DESCRIPTIONS[statusLabel] || "Image failed to load";
        const tooltip = `${statusLabel} ${description}\n${imageUrl}`;

        const badge = document.createElement("span");
        badge.className = "badge image-error";
        badge.textContent = statusLabel;
        badge.title = tooltip;
        badge.setAttribute("aria-label", `Image failed to load: ${tooltip}`);
        container.appendChild(badge);
    }
}

export { ProductCardImageErrorRender };
